export default {
    name: "guideTemplate",
    title: "[deprecated] Guide Template",
    icon: require("./content-icon.svg"),
    category: "other",
    deprecated: true
}